/* KOPIA, IMPORT I RESET — Fala 3 „Obserwowane liczby" (30.09.2026).
 *
 * Ladowany tylko w centrum statystyk gry, obok obserwowane-liczby.js. Zadnego
 * wlasnego magazynu: eksport czyta, a import zapisuje wylacznie przez
 * window.PewniakiObserwowane (lista + preferencje + punkty „obejrzano") i
 * window.PewniakiSzkic (szkice). Gotowe kupony (pewniaki:moje-zestawy:v2),
 * zgoda, push i obce klucze localStorage nie sa dotykane; nigdy localStorage.clear().
 *
 * Plik kopii (wersjonowany JSON, zostaje na urzadzeniu, zawiera prywatne liczby):
 *   { format: 'pewniaki-obserwowane-kopia', wersja: 1, utworzono: ISO,
 *     obserwacje: { okno: '50', gry: { lotto: [3, 17] } },
 *     szkice: { gry: { lotto: { liczby: [..], dodatkowe: [..], cel: 6 } } },
 *     preferencje: { gry: { lotto: { miary: ['h','g','l','p'] } } } }
 *   Bez `zapisany` (id kuponu) i bez punktow „obejrzano".
 *
 * Import: CALY plik jest sprawdzany przed jakimkolwiek zapisem (wersja, rozmiar
 * <= 256 kB, dozwolone klucze, zamkniete listy gier, liczby w pulach, brak
 * duplikatow, limit 20, reguly szkicow, brak szkicu Kaskady). Podsumowanie i
 * jawne potwierdzenie; przy potwierdzeniu ponowna kontrola, czy inna karta nie
 * zmienila stanu od podsumowania (sygnatury trzech kluczy). localStorage nie ma
 * transakcji wielu kluczy, wiec strategia odzyskiwania: migawka surowych wartosci
 * trzech kluczy -> zapis preferencje, szkice, obserwacje -> przy bledzie
 * przywrocenie juz zapisanych kluczy z migawki; gdy przywrocenie tez zawiedzie,
 * komunikat mowi, ktory klucz zostal w stanie posrednim (bez pozornego sukcesu).
 * Punkty „obejrzano" sa czyszczone przy imporcie (powstana przy rzeczywistym
 * obejrzeniu). Klucze odziedziczone (`__proto__`, `constructor`) nie sa grami. */
(function (root, doc) {
    'use strict';
    if (!doc || root.PEWNIAKI_OBS_KOPIA) { return; }
    var FORMAT = 'pewniaki-obserwowane-kopia', WERSJA = 1, MAX_BAJTOW = 256 * 1024;
    var KLUCZE = ['pewniaki:obserwowane-liczby:v1', 'pewniaki:szkic-zestawu:v1', 'pewniaki:obserwowane-panel:v1'];

    function teksty() {
        var e = doc.querySelector('[data-obs-teksty]');
        try { return e ? JSON.parse(e.textContent) || {} : {}; } catch (x) { return {}; }
    }
    var T = teksty();
    function t(k, p) { var s = typeof T[k] === 'string' ? T[k] : k; return s.replace(/\$\{([A-Za-z_]+)\}/g, function (m, n) { return p && Object.prototype.hasOwnProperty.call(p, n) ? String(p[n]) : m; }); }
    function el(tag, klasa, tekst) { var x = doc.createElement(tag); if (klasa) { x.className = klasa; } if (tekst !== undefined) { x.textContent = tekst; } return x; }
    function OBS() { return root.PewniakiObserwowane || null; }
    function SZK() { return root.PewniakiSzkic || null; }
    function wlasne(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
    function surowy(klucz) { try { return root.localStorage.getItem(klucz); } catch (e) { return undefined; } }
    function sygnatury() { return KLUCZE.map(function (k) { var v = surowy(k); return v === undefined ? 'X' : (v === null ? '' : v); }).join('\u0000'); }
    function nazwyGier() {
        var m = {};
        var e = doc.querySelector('[data-obs-nazwy-gier]');
        if (e) { try { m = JSON.parse(e.textContent) || {}; } catch (x) { m = {}; } }
        return m;
    }

    /* ---------------------------------------------------------------- eksport */
    function eksportuj() {
        var O = OBS(), S = SZK();
        var w = O.wczytaj();
        var dok = { format: FORMAT, wersja: WERSJA, utworzono: new Date().toISOString(), obserwacje: { okno: w.stan.okno, gry: w.stan.gry }, szkice: { gry: S ? S.eksport() : {} }, preferencje: { gry: O.preferencje.wszystkie().gry } };
        return dok;
    }
    function nazwaPliku() { var d = new Date(); return 'pewniaki-obserwowane-' + d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + '.json'; }
    function pobierzPlik(dok) {
        var nazwa = nazwaPliku();
        try {
            var blob = new root.Blob([JSON.stringify(dok, null, 2)], { type: 'application/json' });
            var url = root.URL.createObjectURL(blob);
            var a = el('a'); a.href = url; a.download = nazwa; a.rel = 'noopener'; doc.body.appendChild(a); a.click(); doc.body.removeChild(a);
            root.setTimeout(function () { root.URL.revokeObjectURL(url); }, 2000);
            return nazwa;
        } catch (e) { return null; }
    }

    /* ---------------------------------------------------------------- import */
    /** Pelna walidacja pliku -> {ok, powod} albo {ok, dane:{obserwacje, szkice, preferencje}, podsumowanie}. */
    function sprawdzPlik(tekst) {
        if (typeof tekst !== 'string' || tekst.length > MAX_BAJTOW) { return { ok: false, powod: 'za_duzy' }; }
        var d;
        try { d = JSON.parse(tekst); } catch (e) { return { ok: false, powod: 'format' }; }
        if (!d || typeof d !== 'object' || Array.isArray(d) || d.format !== FORMAT) { return { ok: false, powod: 'format' }; }
        if (d.wersja !== WERSJA) { return { ok: false, powod: 'wersja' }; }
        var dozwolone = ['format', 'wersja', 'utworzono', 'obserwacje', 'szkice', 'preferencje'];
        var klucze = Object.keys(d);
        for (var i = 0; i < klucze.length; i++) { if (dozwolone.indexOf(klucze[i]) < 0) { return { ok: false, powod: 'format' }; } }
        var O = OBS(), S = SZK();
        var pule = O.pule(), okna = O.okna;
        // obserwacje
        var obs = wlasne(d, 'obserwacje') ? d.obserwacje : { gry: {} };
        if (!obs || typeof obs !== 'object' || Array.isArray(obs)) { return { ok: false, powod: 'format' }; }
        var okno = wlasne(obs, 'okno') ? String(obs.okno) : null;
        if (okno !== null && okna.indexOf(okno) < 0) { return { ok: false, powod: 'format' }; }
        var gryObs = wlasne(obs, 'gry') ? obs.gry : {};
        if (!gryObs || typeof gryObs !== 'object' || Array.isArray(gryObs)) { return { ok: false, powod: 'format' }; }
        var listaObs = {}, ileObs = 0, kO = Object.keys(gryObs);
        for (i = 0; i < kO.length; i++) {
            var g = kO[i], l = gryObs[g];
            if (!wlasne(pule, g) || !Array.isArray(l) || l.length > O.limit) { return { ok: false, powod: 'format' }; }
            var out = [];
            for (var j = 0; j < l.length; j++) { var n = l[j]; if (typeof n !== 'number' || !isFinite(n) || Math.floor(n) !== n || n < 1 || n > pule[g] || out.indexOf(n) >= 0) { return { ok: false, powod: 'format' }; } out.push(n); }
            if (out.length) { listaObs[g] = out; ileObs += out.length; }
        }
        // szkice
        var szk = wlasne(d, 'szkice') ? d.szkice : { gry: {} };
        if (!szk || typeof szk !== 'object' || Array.isArray(szk)) { return { ok: false, powod: 'format' }; }
        var grySzk = wlasne(szk, 'gry') ? szk.gry : {};
        if (!grySzk || typeof grySzk !== 'object' || Array.isArray(grySzk)) { return { ok: false, powod: 'format' }; }
        var kS = Object.keys(grySzk), szkice = {}, ileSzk = 0;
        if (kS.length) {
            if (!S) { return { ok: false, powod: 'brak_modulu_szkicu' }; }
            for (i = 0; i < kS.length; i++) {
                if (S.gry().indexOf(kS[i]) < 0) { return { ok: false, powod: 'format' }; }
                szkice[kS[i]] = grySzk[kS[i]];
            }
            var ws = S.sprawdzImport(szkice);
            if (!ws.ok) { return { ok: false, powod: 'format' }; }
            ileSzk = Object.keys(ws.stan.gry).length;
        }
        // preferencje
        var pref = wlasne(d, 'preferencje') ? d.preferencje : { gry: {} };
        if (!pref || typeof pref !== 'object' || Array.isArray(pref)) { return { ok: false, powod: 'format' }; }
        var gryPref = wlasne(pref, 'gry') ? pref.gry : {};
        if (!gryPref || typeof gryPref !== 'object' || Array.isArray(gryPref)) { return { ok: false, powod: 'format' }; }
        var kP = Object.keys(gryPref), prefs = {};
        for (i = 0; i < kP.length; i++) {
            var pg = kP[i], pm = gryPref[pg];
            if (!wlasne(pule, pg) || !pm || typeof pm !== 'object' || Array.isArray(pm) || !Array.isArray(pm.miary)) { return { ok: false, powod: 'format' }; }
            var miary = [];
            for (j = 0; j < pm.miary.length; j++) { if (O.preferencje.miary.indexOf(pm.miary[j]) < 0 || miary.indexOf(pm.miary[j]) >= 0) { return { ok: false, powod: 'format' }; } miary.push(pm.miary[j]); }
            prefs[pg] = { miary: miary };
        }
        var gry = {};
        Object.keys(listaObs).forEach(function (x) { gry[x] = true; });
        Object.keys(szkice).forEach(function (x) { gry[x] = true; });
        return { ok: true, dane: { okno: okno, obserwacje: listaObs, szkice: szkice, preferencje: prefs }, podsumowanie: { gry: Object.keys(gry).length, obs: ileObs, szkiceGry: ileSzk, prefGry: kP.length, listaObs: listaObs, szkice: szkice } };
    }
    /** Zapis trzech kluczy z migawka i odtworzeniem (patrz naglowek). */
    function zapiszImport(dane) {
        var O = OBS(), S = SZK();
        var migawka = {};
        for (var i = 0; i < KLUCZE.length; i++) { var v = surowy(KLUCZE[i]); if (v === undefined) { return { ok: false, powod: 'pamiec' }; } migawka[KLUCZE[i]] = v; }
        var zapisane = [];
        function przywroc() {
            var nieudane = [];
            zapisane.forEach(function (k) {
                try { if (migawka[k] === null) { root.localStorage.removeItem(k); } else { root.localStorage.setItem(k, migawka[k]); } if (surowy(k) !== migawka[k]) { nieudane.push(k); } }
                catch (e) { nieudane.push(k); }
            });
            return nieudane;
        }
        var r = O.preferencje.zastap(dane.preferencje);
        if (!r.ok) { return { ok: false, powod: r.powod, nieudane: przywroc() }; }
        zapisane.push('pewniaki:obserwowane-panel:v1');
        if (S) {
            r = S.zastap(dane.szkice);
            if (!r.ok) { return { ok: false, powod: r.powod, nieudane: przywroc() }; }
            zapisane.push('pewniaki:szkic-zestawu:v1');
        }
        r = O.zastap(dane.obserwacje, dane.okno);
        if (!r.ok) { return { ok: false, powod: r.powod, nieudane: przywroc() }; }
        return { ok: true };
    }

    /* ---------------------------------------------------------------- widok */
    function start() {
        var box = doc.querySelector('[data-obs-kopia]');
        var O = OBS();
        if (!box || !O) { return; }
        var q = function (s) { return box.querySelector(s); };
        var status = q('[data-obs-kopia-status]'), eksportBtn = q('[data-obs-eksport]'), importBtn = q('[data-obs-import]'), plik = q('[data-obs-import-plik]');
        var pods = q('[data-obs-import-podsumowanie]'), opis = q('[data-obs-import-opis]'), lista = q('[data-obs-import-lista]'), ostrz = q('[data-obs-import-ostrzezenie]');
        var potwierdz = q('[data-obs-import-potwierdz]'), anuluj = q('[data-obs-import-anuluj]');
        var resetBtn = q('[data-obs-reset-preferencji]'), wyczyscBtn = q('[data-obs-wyczysc]'), wyczyscBox = q('[data-obs-wyczysc-potwierdzenie]'), wyczyscTak = q('[data-obs-wyczysc-potwierdz]'), wyczyscNie = q('[data-obs-wyczysc-anuluj]');
        var nazwy = nazwyGier();
        var oczekujacy = null;     // {dane, sygnatura} po podsumowaniu
        function komunikat(txt, blad) { status.textContent = txt || ''; status.className = blad ? 'blad-pola' : 'tekst-maly'; }
        function nazwa(kod) { return nazwy[kod] || kod; }
        function schowajPods() { pods.hidden = true; oczekujacy = null; while (lista.firstChild) { lista.removeChild(lista.firstChild); } }

        eksportBtn.addEventListener('click', function () {
            var n = pobierzPlik(eksportuj());
            komunikat(n ? t('export_done', { plik: n }) : t('export_failed'), !n);
        });
        importBtn.addEventListener('click', function () { plik.value = ''; plik.click(); });
        plik.addEventListener('change', function () {
            var f = plik.files && plik.files[0];
            if (!f) { return; }
            schowajPods(); komunikat('');
            if (f.size > MAX_BAJTOW) { komunikat(t('import_too_big'), true); return; }
            var czyt = new root.FileReader();
            czyt.onerror = function () { komunikat(t('import_bad'), true); };
            czyt.onload = function () { pokazPodsumowanie(String(czyt.result || '')); };
            czyt.readAsText(f);
        });
        function pokazPodsumowanie(tekst) {
            var w = sprawdzPlik(tekst);
            if (!w.ok) {
                komunikat(t(w.powod === 'za_duzy' ? 'import_too_big' : w.powod === 'wersja' ? 'import_version' : w.powod === 'brak_modulu_szkicu' ? 'import_needs_draft' : 'import_bad'), true);
                return;
            }
            var p = w.podsumowanie;
            opis.textContent = t('import_summary', { gry: p.gry });
            while (lista.firstChild) { lista.removeChild(lista.firstChild); }
            Object.keys(p.listaObs).forEach(function (g) { lista.appendChild(el('li', null, t('import_line_obs', { gra: nazwa(g), n: p.listaObs[g].length }))); });
            Object.keys(p.szkice).forEach(function (g) { var s = p.szkice[g]; lista.appendChild(el('li', null, t('import_line_draft', { gra: nazwa(g), n: (Array.isArray(s.liczby) ? s.liczby.length : 0) + (Array.isArray(s.dodatkowe) ? s.dodatkowe.length : 0) }))); });
            if (p.prefGry) { lista.appendChild(el('li', null, t('import_line_prefs', { n: p.prefGry }))); }
            if (!p.obs && !Object.keys(p.szkice).length) { lista.appendChild(el('li', null, t('import_line_empty'))); }
            ostrz.textContent = t('import_warning');
            oczekujacy = { dane: w.dane, sygnatura: sygnatury(), obs: p.obs, szkice: p.szkiceGry };
            pods.hidden = false;
            potwierdz.focus();
        }
        potwierdz.addEventListener('click', function () {
            if (!oczekujacy) { return; }
            if (sygnatury() !== oczekujacy.sygnatura) {
                // inna karta zmienila stan od podsumowania — nowe podsumowanie i nowa decyzja
                var d = oczekujacy.dane; schowajPods();
                komunikat(t('import_conflict'), true);
                pokazPodsumowanie(JSON.stringify({ format: FORMAT, wersja: WERSJA, obserwacje: { okno: d.okno === null ? undefined : d.okno, gry: d.obserwacje }, szkice: { gry: d.szkice }, preferencje: { gry: d.preferencje } }));
                return;
            }
            var r = zapiszImport(oczekujacy.dane);
            var obs = oczekujacy.obs, szk = oczekujacy.szkice;
            schowajPods();
            if (r.ok) { komunikat(t('import_done', { obs: obs, szkice: szk }), false); return; }
            if (r.powod === 'pamiec') { komunikat(t('import_storage'), true); return; }
            if (r.nieudane && r.nieudane.length) { komunikat(t('import_partial', { co: r.nieudane.join(', ') }), true); return; }
            komunikat(t('import_failed'), true);
        });
        anuluj.addEventListener('click', function () { schowajPods(); komunikat(''); importBtn.focus(); });

        resetBtn.addEventListener('click', function () {
            var r = O.preferencje.reset();
            komunikat(r.ok ? t('reset_prefs_done') : (r.powod === 'pamiec' ? t('storage_off') : t('reset_prefs_failed')), !r.ok);
        });
        wyczyscBtn.addEventListener('click', function () { wyczyscBox.hidden = false; wyczyscTak.focus(); });
        wyczyscNie.addEventListener('click', function () { wyczyscBox.hidden = true; wyczyscBtn.focus(); });
        wyczyscTak.addEventListener('click', function () {
            wyczyscBox.hidden = true;
            var S = SZK(), nieudane = [];
            var r1 = O.wyczyscWszystko(); if (!r1.ok) { nieudane.push('obserwacje'); }
            if (S) { var r2 = S.wyczyscWszystko(); if (!r2.ok) { nieudane.push('szkice'); } }
            komunikat(nieudane.length ? t('clear_failed', { co: nieudane.join(', ') }) : t('clear_done'), nieudane.length > 0);
            wyczyscBtn.focus();
        });
        box.hidden = false;
    }
    root.PEWNIAKI_OBS_KOPIA = { sprawdzPlik: sprawdzPlik, eksportuj: eksportuj, FORMAT: FORMAT, WERSJA: WERSJA };
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
})(typeof window !== 'undefined' ? window : this, typeof document !== 'undefined' ? document : null);
